import account from '@/core/routes/paths/panel/account'
import home from "@/core/routes/paths/panel/home";
import company from "@/core/routes/paths/panel/company";

export default [
    {
        path: "/",
        redirect: '/home',
        component: () => import("@/layout/Master"),
        children: [
            ...home,
            ...account,
            ...company,
         ]
    }
]

